import { useEffect, useRef, useState } from "react";
import { HERO_VIDEO_URL, HERO_VIDEO_FALLBACK } from "@/data/content";

export default function HeroVideo() {
  const videoRef = useRef(null);
  const [src, setSrc] = useState(HERO_VIDEO_URL);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const onErr = () => {
      if (src !== HERO_VIDEO_FALLBACK) {
        setSrc(HERO_VIDEO_FALLBACK);
      }
    };
    v.addEventListener("error", onErr);
    return () => v.removeEventListener("error", onErr);
  }, [src]);

  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="hero-video-wrap">
      <video
        ref={videoRef}
        key={src}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster="https://images.unsplash.com/photo-1545128485-c400e7702796?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="hero-video"
      >
        <source src={src} type="video/mp4" />
        <source src={src} type="video/quicktime" />
      </video>
      {/* dark gradient overlays */}
      <div className="absolute inset-0 hero-grad pointer-events-none" />
      <div className="absolute inset-0 hero-grad-side pointer-events-none hidden md:block" />
      {/* subtle vignette */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.6) 100%)",
        }}
      />
      {/* film grain */}
      <div className="absolute inset-0 grain pointer-events-none opacity-40" />
    </div>
  );
}
